import { useEffect, useState } from "react";
import { playSfx } from "@/lib/sfx";
import { impact } from "@/lib/fx";

const CONFIRM_HOLD_MS = 2000;

export default function DiodeScreen({ number, previous, onTap, onConfirmed }) {
  const [connected, setConnected] = useState(false);
  const slug = number.toLowerCase();

  useEffect(() => {
    if (!connected) return;
    const t = setTimeout(onConfirmed, CONFIRM_HOLD_MS);
    return () => clearTimeout(t);
  }, [connected, onConfirmed]);

  const confirm = () => {
    if (connected) return;
    onTap?.();
    const level = number === "ONE" ? 1 : 2;
    playSfx(level === 1 ? "diode1_impact" : "diode2_impact", { gain: level === 1 ? 0.9 : 1 }).then(() => impact(level));
    setConnected(true);
  };

  return (
    <div className="diode" data-testid={`diode-${slug}-screen`} onClick={confirm}>
      <p className="diode-kicker">SPORE // BIO-SIGNAL TRANSLATOR v4.7 // LABORATORY TERMINAL 03</p>
      {previous && (
        <p className="diode-ok diode-ok-prev" data-testid="diode-previous-status">
          DIODE {previous}: CONNECTED ✓
        </p>
      )}
      {connected ? (
        <p className="diode-ok glow" data-testid={`diode-${slug}-connected`}>
          DIODE {number}: CONNECTED ✓
        </p>
      ) : (
        <>
          <h1 className="diode-prompt glow" data-testid={`diode-${slug}-prompt`}>CONNECT DIODE {number}</h1>
          <button
            type="button"
            className="diode-btn"
            data-testid={`diode-${slug}-confirm-button`}
            onClick={(e) => { e.stopPropagation(); confirm(); }}
          >
            [ CONNECTED ]
          </button>
        </>
      )}
    </div>
  );
}
